/* eslint-disable */
//
// This file is auto-generated by build.py.
// Do not modify manually, please do: bun run build:wasm.
//

/**
 * PDFium function schema with original C type names.
 * Format: [paramTypes[], returnType]
 */
export type PdfiumSchema = {
  FORM_CanRedo: [["FPDF_FORMHANDLE", "FPDF_PAGE"], "FPDF_BOOL"]
  FORM_CanUndo: [["FPDF_FORMHANDLE", "FPDF_PAGE"], "FPDF_BOOL"]
  FORM_DoDocumentAAction: [["FPDF_FORMHANDLE", "int"], "void"]
  FORM_DoDocumentJSAction: [["FPDF_FORMHANDLE"], "void"]
  FORM_DoDocumentOpenAction: [["FPDF_FORMHANDLE"], "void"]
  FORM_DoPageAAction: [["FPDF_PAGE", "FPDF_FORMHANDLE", "int"], "void"]
  FORM_ForceToKillFocus: [["FPDF_FORMHANDLE"], "FPDF_BOOL"]
  FORM_GetFocusedAnnot: [
    ["FPDF_FORMHANDLE", "int *", "FPDF_ANNOTATION *"],
    "FPDF_BOOL",
  ]
  FORM_GetFocusedText: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "void *", "unsigned long"],
    "unsigned long",
  ]
  FORM_GetSelectedText: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "void *", "unsigned long"],
    "unsigned long",
  ]
  FORM_IsIndexSelected: [["FPDF_FORMHANDLE", "FPDF_PAGE", "int"], "FPDF_BOOL"]
  FORM_OnAfterLoadPage: [["FPDF_PAGE", "FPDF_FORMHANDLE"], "void"]
  FORM_OnBeforeClosePage: [["FPDF_PAGE", "FPDF_FORMHANDLE"], "void"]
  FORM_OnChar: [["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "int"], "FPDF_BOOL"]
  FORM_OnFocus: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "double", "double"],
    "FPDF_BOOL",
  ]
  FORM_OnKeyDown: [["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "int"], "FPDF_BOOL"]
  FORM_OnKeyUp: [["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "int"], "FPDF_BOOL"]
  FORM_OnLButtonDoubleClick: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "double", "double"],
    "FPDF_BOOL",
  ]
  FORM_OnLButtonDown: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "double", "double"],
    "FPDF_BOOL",
  ]
  FORM_OnLButtonUp: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "double", "double"],
    "FPDF_BOOL",
  ]
  FORM_OnMouseMove: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "double", "double"],
    "FPDF_BOOL",
  ]
  FORM_OnMouseWheel: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "FS_POINTF *", "int", "int"],
    "FPDF_BOOL",
  ]
  FORM_OnRButtonDown: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "double", "double"],
    "FPDF_BOOL",
  ]
  FORM_OnRButtonUp: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "double", "double"],
    "FPDF_BOOL",
  ]
  FORM_Redo: [["FPDF_FORMHANDLE", "FPDF_PAGE"], "FPDF_BOOL"]
  FORM_ReplaceAndKeepSelection: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "FPDF_WIDESTRING"],
    "void",
  ]
  FORM_ReplaceSelection: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "FPDF_WIDESTRING"],
    "void",
  ]
  FORM_SelectAllText: [["FPDF_FORMHANDLE", "FPDF_PAGE"], "FPDF_BOOL"]
  FORM_SetFocusedAnnot: [["FPDF_FORMHANDLE", "FPDF_ANNOTATION"], "FPDF_BOOL"]
  FORM_SetIndexSelected: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "int", "FPDF_BOOL"],
    "FPDF_BOOL",
  ]
  FORM_Undo: [["FPDF_FORMHANDLE", "FPDF_PAGE"], "FPDF_BOOL"]
  FPDF_AddInstalledFont: [["void *", "char *", "int"], "void"]
  FPDF_CloseDocument: [["FPDF_DOCUMENT"], "void"]
  FPDF_ClosePage: [["FPDF_PAGE"], "void"]
  FPDF_CloseXObject: [["FPDF_XOBJECT"], "void"]
  FPDF_CopyViewerPreferences: [["FPDF_DOCUMENT", "FPDF_DOCUMENT"], "FPDF_BOOL"]
  FPDF_CountNamedDests: [["FPDF_DOCUMENT"], "FPDF_DWORD"]
  FPDF_CreateClipPath: [["float", "float", "float", "float"], "FPDF_CLIPPATH"]
  FPDF_CreateNewDocument: [[], "FPDF_DOCUMENT"]
  FPDF_DestroyClipPath: [["FPDF_CLIPPATH"], "void"]
  FPDF_DestroyLibrary: [[], "void"]
  FPDF_DeviceToPage: [
    [
      "FPDF_PAGE",
      "int",
      "int",
      "int",
      "int",
      "int",
      "int",
      "int",
      "double *",
      "double *",
    ],
    "FPDF_BOOL",
  ]
  FPDF_DocumentHasValidCrossReferenceTable: [["FPDF_DOCUMENT"], "FPDF_BOOL"]
  FPDF_FFLDraw: [
    [
      "FPDF_FORMHANDLE",
      "FPDF_BITMAP",
      "FPDF_PAGE",
      "int",
      "int",
      "int",
      "int",
      "int",
      "int",
    ],
    "void",
  ]
  FPDF_FreeDefaultSystemFontInfo: [["FPDF_SYSFONTINFO *"], "void"]
  FPDF_GetDefaultSystemFontInfo: [[], "FPDF_SYSFONTINFO *"]
  FPDF_GetDefaultTTFMap: [[], "FPDF_CharsetFontMap *"]
  FPDF_GetDefaultTTFMapCount: [[], "size_t"]
  FPDF_GetDefaultTTFMapEntry: [["size_t"], "FPDF_CharsetFontMap *"]
  FPDF_GetDocPermissions: [["FPDF_DOCUMENT"], "unsigned long"]
  FPDF_GetDocUserPermissions: [["FPDF_DOCUMENT"], "unsigned long"]
  FPDF_GetFileIdentifier: [
    ["FPDF_DOCUMENT", "FPDF_FILEIDTYPE", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_GetFileVersion: [["FPDF_DOCUMENT", "int *"], "FPDF_BOOL"]
  FPDF_GetFormType: [["FPDF_DOCUMENT"], "int"]
  FPDF_GetLastError: [[], "unsigned long"]
  FPDF_GetMetaText: [
    ["FPDF_DOCUMENT", "FPDF_BYTESTRING", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_GetNamedDest: [["FPDF_DOCUMENT", "int", "void *", "long *"], "FPDF_DEST"]
  FPDF_GetNamedDestByName: [["FPDF_DOCUMENT", "FPDF_BYTESTRING"], "FPDF_DEST"]
  FPDF_GetPageAAction: [["FPDF_PAGE", "int"], "FPDF_ACTION"]
  FPDF_GetPageBoundingBox: [["FPDF_PAGE", "FS_RECTF *"], "FPDF_BOOL"]
  FPDF_GetPageCount: [["FPDF_DOCUMENT"], "int"]
  FPDF_GetPageHeight: [["FPDF_PAGE"], "double"]
  FPDF_GetPageHeightF: [["FPDF_PAGE"], "float"]
  FPDF_GetPageLabel: [
    ["FPDF_DOCUMENT", "int", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_GetPageSizeByIndex: [
    ["FPDF_DOCUMENT", "int", "double *", "double *"],
    "int",
  ]
  FPDF_GetPageSizeByIndexF: [
    ["FPDF_DOCUMENT", "int", "FS_SIZEF *"],
    "FPDF_BOOL",
  ]
  FPDF_GetPageWidth: [["FPDF_PAGE"], "double"]
  FPDF_GetPageWidthF: [["FPDF_PAGE"], "float"]
  FPDF_GetSecurityHandlerRevision: [["FPDF_DOCUMENT"], "int"]
  FPDF_GetSignatureCount: [["FPDF_DOCUMENT"], "int"]
  FPDF_GetSignatureObject: [["FPDF_DOCUMENT", "int"], "FPDF_SIGNATURE"]
  FPDF_GetTrailerEnds: [
    ["FPDF_DOCUMENT", "unsigned int *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_GetXFAPacketContent: [
    ["FPDF_DOCUMENT", "int", "void *", "unsigned long", "unsigned long *"],
    "FPDF_BOOL",
  ]
  FPDF_GetXFAPacketCount: [["FPDF_DOCUMENT"], "int"]
  FPDF_GetXFAPacketName: [
    ["FPDF_DOCUMENT", "int", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_ImportNPagesToOne: [
    ["FPDF_DOCUMENT", "float", "float", "size_t", "size_t"],
    "FPDF_DOCUMENT",
  ]
  FPDF_ImportPages: [
    ["FPDF_DOCUMENT", "FPDF_DOCUMENT", "FPDF_BYTESTRING", "int"],
    "FPDF_BOOL",
  ]
  FPDF_ImportPagesByIndex: [
    ["FPDF_DOCUMENT", "FPDF_DOCUMENT", "int *", "unsigned long", "int"],
    "FPDF_BOOL",
  ]
  FPDF_InitLibrary: [[], "void"]
  FPDF_InitLibraryWithConfig: [["FPDF_LIBRARY_CONFIG *"], "void"]
  FPDF_LoadCustomDocument: [
    ["FPDF_FILEACCESS *", "FPDF_BYTESTRING"],
    "FPDF_DOCUMENT",
  ]
  FPDF_LoadDocument: [["FPDF_STRING", "FPDF_BYTESTRING"], "FPDF_DOCUMENT"]
  FPDF_LoadMemDocument: [["void *", "int", "FPDF_BYTESTRING"], "FPDF_DOCUMENT"]
  FPDF_LoadMemDocument64: [
    ["void *", "size_t", "FPDF_BYTESTRING"],
    "FPDF_DOCUMENT",
  ]
  FPDF_LoadPage: [["FPDF_DOCUMENT", "int"], "FPDF_PAGE"]
  FPDF_LoadXFA: [["FPDF_DOCUMENT"], "FPDF_BOOL"]
  FPDF_MovePages: [
    ["FPDF_DOCUMENT", "int *", "unsigned long", "int"],
    "FPDF_BOOL",
  ]
  FPDF_NewFormObjectFromXObject: [["FPDF_XOBJECT"], "FPDF_PAGEOBJECT"]
  FPDF_NewXObjectFromPage: [
    ["FPDF_DOCUMENT", "FPDF_DOCUMENT", "int"],
    "FPDF_XOBJECT",
  ]
  FPDF_PageToDevice: [
    [
      "FPDF_PAGE",
      "int",
      "int",
      "int",
      "int",
      "int",
      "double",
      "double",
      "int *",
      "int *",
    ],
    "FPDF_BOOL",
  ]
  FPDF_RemoveFormFieldHighlight: [["FPDF_FORMHANDLE"], "void"]
  FPDF_RenderPage_Close: [["FPDF_PAGE"], "void"]
  FPDF_RenderPage_Continue: [["FPDF_PAGE", "IFSDK_PAUSE *"], "int"]
  FPDF_RenderPageBitmap: [
    ["FPDF_BITMAP", "FPDF_PAGE", "int", "int", "int", "int", "int", "int"],
    "void",
  ]
  FPDF_RenderPageBitmap_Start: [
    [
      "FPDF_BITMAP",
      "FPDF_PAGE",
      "int",
      "int",
      "int",
      "int",
      "int",
      "int",
      "IFSDK_PAUSE *",
    ],
    "int",
  ]
  FPDF_RenderPageBitmapWithColorScheme_Start: [
    [
      "FPDF_BITMAP",
      "FPDF_PAGE",
      "int",
      "int",
      "int",
      "int",
      "int",
      "int",
      "FPDF_COLORSCHEME *",
      "IFSDK_PAUSE *",
    ],
    "int",
  ]
  FPDF_RenderPageBitmapWithMatrix: [
    ["FPDF_BITMAP", "FPDF_PAGE", "FS_MATRIX *", "FS_RECTF *", "int"],
    "void",
  ]
  FPDF_SaveAsCopy: [
    ["FPDF_DOCUMENT", "FPDF_FILEWRITE *", "FPDF_DWORD"],
    "FPDF_BOOL",
  ]
  FPDF_SaveWithVersion: [
    ["FPDF_DOCUMENT", "FPDF_FILEWRITE *", "FPDF_DWORD", "int"],
    "FPDF_BOOL",
  ]
  FPDF_SetFormFieldHighlightAlpha: [
    ["FPDF_FORMHANDLE", "unsigned char"],
    "void",
  ]
  FPDF_SetFormFieldHighlightColor: [
    ["FPDF_FORMHANDLE", "int", "unsigned long"],
    "void",
  ]
  FPDF_SetSandBoxPolicy: [["FPDF_DWORD", "FPDF_BOOL"], "void"]
  FPDF_SetSystemFontInfo: [["FPDF_SYSFONTINFO *"], "void"]
  FPDF_StructElement_Attr_CountChildren: [
    ["FPDF_STRUCTELEMENT_ATTR_VALUE"],
    "int",
  ]
  FPDF_StructElement_Attr_GetBlobValue: [
    [
      "FPDF_STRUCTELEMENT_ATTR_VALUE",
      "void *",
      "unsigned long",
      "unsigned long *",
    ],
    "FPDF_BOOL",
  ]
  FPDF_StructElement_Attr_GetBooleanValue: [
    ["FPDF_STRUCTELEMENT_ATTR_VALUE", "FPDF_BOOL *"],
    "FPDF_BOOL",
  ]
  FPDF_StructElement_Attr_GetChildAtIndex: [
    ["FPDF_STRUCTELEMENT_ATTR_VALUE", "int"],
    "FPDF_STRUCTELEMENT_ATTR_VALUE",
  ]
  FPDF_StructElement_Attr_GetCount: [["FPDF_STRUCTELEMENT_ATTR"], "int"]
  FPDF_StructElement_Attr_GetName: [
    [
      "FPDF_STRUCTELEMENT_ATTR",
      "int",
      "void *",
      "unsigned long",
      "unsigned long *",
    ],
    "FPDF_BOOL",
  ]
  FPDF_StructElement_Attr_GetNumberValue: [
    ["FPDF_STRUCTELEMENT_ATTR_VALUE", "float *"],
    "FPDF_BOOL",
  ]
  FPDF_StructElement_Attr_GetStringValue: [
    [
      "FPDF_STRUCTELEMENT_ATTR_VALUE",
      "void *",
      "unsigned long",
      "unsigned long *",
    ],
    "FPDF_BOOL",
  ]
  FPDF_StructElement_Attr_GetType: [
    ["FPDF_STRUCTELEMENT_ATTR_VALUE"],
    "FPDF_OBJECT_TYPE",
  ]
  FPDF_StructElement_Attr_GetValue: [
    ["FPDF_STRUCTELEMENT_ATTR", "FPDF_BYTESTRING"],
    "FPDF_STRUCTELEMENT_ATTR_VALUE",
  ]
  FPDF_StructElement_CountChildren: [["FPDF_STRUCTELEMENT"], "int"]
  FPDF_StructElement_GetActualText: [
    ["FPDF_STRUCTELEMENT", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_StructElement_GetAltText: [
    ["FPDF_STRUCTELEMENT", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_StructElement_GetAttributeAtIndex: [
    ["FPDF_STRUCTELEMENT", "int"],
    "FPDF_STRUCTELEMENT_ATTR",
  ]
  FPDF_StructElement_GetAttributeCount: [["FPDF_STRUCTELEMENT"], "int"]
  FPDF_StructElement_GetChildAtIndex: [
    ["FPDF_STRUCTELEMENT", "int"],
    "FPDF_STRUCTELEMENT",
  ]
  FPDF_StructElement_GetChildMarkedContentID: [
    ["FPDF_STRUCTELEMENT", "int"],
    "int",
  ]
  FPDF_StructElement_GetID: [
    ["FPDF_STRUCTELEMENT", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_StructElement_GetLang: [
    ["FPDF_STRUCTELEMENT", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_StructElement_GetMarkedContentID: [["FPDF_STRUCTELEMENT"], "int"]
  FPDF_StructElement_GetMarkedContentIdAtIndex: [
    ["FPDF_STRUCTELEMENT", "int"],
    "int",
  ]
  FPDF_StructElement_GetMarkedContentIdCount: [["FPDF_STRUCTELEMENT"], "int"]
  FPDF_StructElement_GetObjType: [
    ["FPDF_STRUCTELEMENT", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_StructElement_GetParent: [["FPDF_STRUCTELEMENT"], "FPDF_STRUCTELEMENT"]
  FPDF_StructElement_GetStringAttribute: [
    ["FPDF_STRUCTELEMENT", "FPDF_BYTESTRING", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_StructElement_GetTitle: [
    ["FPDF_STRUCTELEMENT", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_StructElement_GetType: [
    ["FPDF_STRUCTELEMENT", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_StructTree_Close: [["FPDF_STRUCTTREE"], "void"]
  FPDF_StructTree_CountChildren: [["FPDF_STRUCTTREE"], "int"]
  FPDF_StructTree_GetChildAtIndex: [
    ["FPDF_STRUCTTREE", "int"],
    "FPDF_STRUCTELEMENT",
  ]
  FPDF_StructTree_GetForPage: [["FPDF_PAGE"], "FPDF_STRUCTTREE"]
  FPDF_VIEWERREF_GetDuplex: [["FPDF_DOCUMENT"], "FPDF_DUPLEXTYPE"]
  FPDF_VIEWERREF_GetName: [
    ["FPDF_DOCUMENT", "FPDF_BYTESTRING", "char *", "unsigned long"],
    "unsigned long",
  ]
  FPDF_VIEWERREF_GetNumCopies: [["FPDF_DOCUMENT"], "int"]
  FPDF_VIEWERREF_GetPrintPageRange: [["FPDF_DOCUMENT"], "FPDF_PAGERANGE"]
  FPDF_VIEWERREF_GetPrintPageRangeCount: [["FPDF_PAGERANGE"], "size_t"]
  FPDF_VIEWERREF_GetPrintPageRangeElement: [["FPDF_PAGERANGE", "size_t"], "int"]
  FPDF_VIEWERREF_GetPrintScaling: [["FPDF_DOCUMENT"], "FPDF_BOOL"]
  FPDFAction_GetDest: [["FPDF_DOCUMENT", "FPDF_ACTION"], "FPDF_DEST"]
  FPDFAction_GetFilePath: [
    ["FPDF_ACTION", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAction_GetType: [["FPDF_ACTION"], "unsigned long"]
  FPDFAction_GetURIPath: [
    ["FPDF_DOCUMENT", "FPDF_ACTION", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAnnot_AddFileAttachment: [
    ["FPDF_ANNOTATION", "FPDF_WIDESTRING"],
    "FPDF_ATTACHMENT",
  ]
  FPDFAnnot_AddInkStroke: [["FPDF_ANNOTATION", "FS_POINTF *", "size_t"], "int"]
  FPDFAnnot_AppendAttachmentPoints: [
    ["FPDF_ANNOTATION", "FS_QUADPOINTSF *"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_AppendObject: [["FPDF_ANNOTATION", "FPDF_PAGEOBJECT"], "FPDF_BOOL"]
  FPDFAnnot_CountAttachmentPoints: [["FPDF_ANNOTATION"], "size_t"]
  FPDFAnnot_GetAP: [
    [
      "FPDF_ANNOTATION",
      "FPDF_ANNOT_APPEARANCEMODE",
      "FPDF_WCHAR *",
      "unsigned long",
    ],
    "unsigned long",
  ]
  FPDFAnnot_GetAttachmentPoints: [
    ["FPDF_ANNOTATION", "size_t", "FS_QUADPOINTSF *"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_GetBorder: [
    ["FPDF_ANNOTATION", "float *", "float *", "float *"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_GetColor: [
    [
      "FPDF_ANNOTATION",
      "FPDFANNOT_COLORTYPE",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
    ],
    "FPDF_BOOL",
  ]
  FPDFAnnot_GetFileAttachment: [["FPDF_ANNOTATION"], "FPDF_ATTACHMENT"]
  FPDFAnnot_GetFlags: [["FPDF_ANNOTATION"], "int"]
  FPDFAnnot_GetFocusableSubtypes: [
    ["FPDF_FORMHANDLE", "FPDF_ANNOTATION_SUBTYPE *", "size_t"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_GetFocusableSubtypesCount: [["FPDF_FORMHANDLE"], "int"]
  FPDFAnnot_GetFontColor: [
    [
      "FPDF_FORMHANDLE",
      "FPDF_ANNOTATION",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
    ],
    "FPDF_BOOL",
  ]
  FPDFAnnot_GetFontSize: [
    ["FPDF_FORMHANDLE", "FPDF_ANNOTATION", "float *"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_GetFormAdditionalActionJavaScript: [
    [
      "FPDF_FORMHANDLE",
      "FPDF_ANNOTATION",
      "int",
      "FPDF_WCHAR *",
      "unsigned long",
    ],
    "unsigned long",
  ]
  FPDFAnnot_GetFormControlCount: [["FPDF_FORMHANDLE", "FPDF_ANNOTATION"], "int"]
  FPDFAnnot_GetFormControlIndex: [["FPDF_FORMHANDLE", "FPDF_ANNOTATION"], "int"]
  FPDFAnnot_GetFormFieldAlternateName: [
    ["FPDF_FORMHANDLE", "FPDF_ANNOTATION", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAnnot_GetFormFieldAtPoint: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "FS_POINTF *"],
    "FPDF_ANNOTATION",
  ]
  FPDFAnnot_GetFormFieldExportValue: [
    ["FPDF_FORMHANDLE", "FPDF_ANNOTATION", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAnnot_GetFormFieldFlags: [["FPDF_FORMHANDLE", "FPDF_ANNOTATION"], "int"]
  FPDFAnnot_GetFormFieldName: [
    ["FPDF_FORMHANDLE", "FPDF_ANNOTATION", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAnnot_GetFormFieldType: [["FPDF_FORMHANDLE", "FPDF_ANNOTATION"], "int"]
  FPDFAnnot_GetFormFieldValue: [
    ["FPDF_FORMHANDLE", "FPDF_ANNOTATION", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAnnot_GetInkListCount: [["FPDF_ANNOTATION"], "unsigned long"]
  FPDFAnnot_GetInkListPath: [
    ["FPDF_ANNOTATION", "unsigned long", "FS_POINTF *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAnnot_GetLine: [
    ["FPDF_ANNOTATION", "FS_POINTF *", "FS_POINTF *"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_GetLink: [["FPDF_ANNOTATION"], "FPDF_LINK"]
  FPDFAnnot_GetLinkedAnnot: [
    ["FPDF_ANNOTATION", "FPDF_BYTESTRING"],
    "FPDF_ANNOTATION",
  ]
  FPDFAnnot_GetNumberValue: [
    ["FPDF_ANNOTATION", "FPDF_BYTESTRING", "float *"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_GetObject: [["FPDF_ANNOTATION", "int"], "FPDF_PAGEOBJECT"]
  FPDFAnnot_GetObjectCount: [["FPDF_ANNOTATION"], "int"]
  FPDFAnnot_GetOptionCount: [["FPDF_FORMHANDLE", "FPDF_ANNOTATION"], "int"]
  FPDFAnnot_GetOptionLabel: [
    [
      "FPDF_FORMHANDLE",
      "FPDF_ANNOTATION",
      "int",
      "FPDF_WCHAR *",
      "unsigned long",
    ],
    "unsigned long",
  ]
  FPDFAnnot_GetRect: [["FPDF_ANNOTATION", "FS_RECTF *"], "FPDF_BOOL"]
  FPDFAnnot_GetStringValue: [
    ["FPDF_ANNOTATION", "FPDF_BYTESTRING", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAnnot_GetSubtype: [["FPDF_ANNOTATION"], "FPDF_ANNOTATION_SUBTYPE"]
  FPDFAnnot_GetValueType: [
    ["FPDF_ANNOTATION", "FPDF_BYTESTRING"],
    "FPDF_OBJECT_TYPE",
  ]
  FPDFAnnot_GetVertices: [
    ["FPDF_ANNOTATION", "FS_POINTF *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAnnot_HasAttachmentPoints: [["FPDF_ANNOTATION"], "FPDF_BOOL"]
  FPDFAnnot_HasKey: [["FPDF_ANNOTATION", "FPDF_BYTESTRING"], "FPDF_BOOL"]
  FPDFAnnot_IsChecked: [["FPDF_FORMHANDLE", "FPDF_ANNOTATION"], "FPDF_BOOL"]
  FPDFAnnot_IsObjectSupportedSubtype: [["FPDF_ANNOTATION_SUBTYPE"], "FPDF_BOOL"]
  FPDFAnnot_IsOptionSelected: [
    ["FPDF_FORMHANDLE", "FPDF_ANNOTATION", "int"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_IsSupportedSubtype: [["FPDF_ANNOTATION_SUBTYPE"], "FPDF_BOOL"]
  FPDFAnnot_RemoveInkList: [["FPDF_ANNOTATION"], "FPDF_BOOL"]
  FPDFAnnot_RemoveObject: [["FPDF_ANNOTATION", "int"], "FPDF_BOOL"]
  FPDFAnnot_SetAP: [
    ["FPDF_ANNOTATION", "FPDF_ANNOT_APPEARANCEMODE", "FPDF_WIDESTRING"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_SetAttachmentPoints: [
    ["FPDF_ANNOTATION", "size_t", "FS_QUADPOINTSF *"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_SetBorder: [
    ["FPDF_ANNOTATION", "float", "float", "float"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_SetColor: [
    [
      "FPDF_ANNOTATION",
      "FPDFANNOT_COLORTYPE",
      "unsigned int",
      "unsigned int",
      "unsigned int",
      "unsigned int",
    ],
    "FPDF_BOOL",
  ]
  FPDFAnnot_SetFlags: [["FPDF_ANNOTATION", "int"], "FPDF_BOOL"]
  FPDFAnnot_SetFocusableSubtypes: [
    ["FPDF_FORMHANDLE", "FPDF_ANNOTATION_SUBTYPE *", "size_t"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_SetFontColor: [
    [
      "FPDF_FORMHANDLE",
      "FPDF_ANNOTATION",
      "unsigned int",
      "unsigned int",
      "unsigned int",
    ],
    "FPDF_BOOL",
  ]
  FPDFAnnot_SetFormFieldFlags: [
    ["FPDF_FORMHANDLE", "FPDF_ANNOTATION", "int"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_SetRect: [["FPDF_ANNOTATION", "FS_RECTF *"], "FPDF_BOOL"]
  FPDFAnnot_SetStringValue: [
    ["FPDF_ANNOTATION", "FPDF_BYTESTRING", "FPDF_WIDESTRING"],
    "FPDF_BOOL",
  ]
  FPDFAnnot_SetURI: [["FPDF_ANNOTATION", "char *"], "FPDF_BOOL"]
  FPDFAnnot_UpdateObject: [["FPDF_ANNOTATION", "FPDF_PAGEOBJECT"], "FPDF_BOOL"]
  FPDFAttachment_GetFile: [
    ["FPDF_ATTACHMENT", "void *", "unsigned long", "unsigned long *"],
    "FPDF_BOOL",
  ]
  FPDFAttachment_GetName: [
    ["FPDF_ATTACHMENT", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAttachment_GetStringValue: [
    ["FPDF_ATTACHMENT", "FPDF_BYTESTRING", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAttachment_GetSubtype: [
    ["FPDF_ATTACHMENT", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFAttachment_GetValueType: [
    ["FPDF_ATTACHMENT", "FPDF_BYTESTRING"],
    "FPDF_OBJECT_TYPE",
  ]
  FPDFAttachment_HasKey: [["FPDF_ATTACHMENT", "FPDF_BYTESTRING"], "FPDF_BOOL"]
  FPDFAttachment_SetFile: [
    ["FPDF_ATTACHMENT", "FPDF_DOCUMENT", "void *", "unsigned long"],
    "FPDF_BOOL",
  ]
  FPDFAttachment_SetStringValue: [
    ["FPDF_ATTACHMENT", "FPDF_BYTESTRING", "FPDF_WIDESTRING"],
    "FPDF_BOOL",
  ]
  FPDFAvail_Create: [["FX_FILEAVAIL *", "FPDF_FILEACCESS *"], "FPDF_AVAIL"]
  FPDFAvail_Destroy: [["FPDF_AVAIL"], "void"]
  FPDFAvail_GetDocument: [["FPDF_AVAIL", "FPDF_BYTESTRING"], "FPDF_DOCUMENT"]
  FPDFAvail_GetFirstPageNum: [["FPDF_DOCUMENT"], "int"]
  FPDFAvail_IsDocAvail: [["FPDF_AVAIL", "FX_DOWNLOADHINTS *"], "int"]
  FPDFAvail_IsFormAvail: [["FPDF_AVAIL", "FX_DOWNLOADHINTS *"], "int"]
  FPDFAvail_IsLinearized: [["FPDF_AVAIL"], "int"]
  FPDFAvail_IsPageAvail: [["FPDF_AVAIL", "int", "FX_DOWNLOADHINTS *"], "int"]
  FPDFBitmap_Create: [["int", "int", "int"], "FPDF_BITMAP"]
  FPDFBitmap_CreateEx: [["int", "int", "int", "void *", "int"], "FPDF_BITMAP"]
  FPDFBitmap_Destroy: [["FPDF_BITMAP"], "void"]
  FPDFBitmap_FillRect: [
    ["FPDF_BITMAP", "int", "int", "int", "int", "FPDF_DWORD"],
    "FPDF_BOOL",
  ]
  FPDFBitmap_GetBuffer: [["FPDF_BITMAP"], "void *"]
  FPDFBitmap_GetFormat: [["FPDF_BITMAP"], "int"]
  FPDFBitmap_GetHeight: [["FPDF_BITMAP"], "int"]
  FPDFBitmap_GetStride: [["FPDF_BITMAP"], "int"]
  FPDFBitmap_GetWidth: [["FPDF_BITMAP"], "int"]
  FPDFBookmark_Find: [["FPDF_DOCUMENT", "FPDF_WIDESTRING"], "FPDF_BOOKMARK"]
  FPDFBookmark_GetAction: [["FPDF_BOOKMARK"], "FPDF_ACTION"]
  FPDFBookmark_GetCount: [["FPDF_BOOKMARK"], "int"]
  FPDFBookmark_GetDest: [["FPDF_DOCUMENT", "FPDF_BOOKMARK"], "FPDF_DEST"]
  FPDFBookmark_GetFirstChild: [
    ["FPDF_DOCUMENT", "FPDF_BOOKMARK"],
    "FPDF_BOOKMARK",
  ]
  FPDFBookmark_GetNextSibling: [
    ["FPDF_DOCUMENT", "FPDF_BOOKMARK"],
    "FPDF_BOOKMARK",
  ]
  FPDFBookmark_GetTitle: [
    ["FPDF_BOOKMARK", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFCatalog_IsTagged: [["FPDF_DOCUMENT"], "FPDF_BOOL"]
  FPDFCatalog_SetLanguage: [["FPDF_DOCUMENT", "FPDF_BYTESTRING"], "FPDF_BOOL"]
  FPDFClipPath_CountPaths: [["FPDF_CLIPPATH"], "int"]
  FPDFClipPath_CountPathSegments: [["FPDF_CLIPPATH", "int"], "int"]
  FPDFClipPath_GetPathSegment: [
    ["FPDF_CLIPPATH", "int", "int"],
    "FPDF_PATHSEGMENT",
  ]
  FPDFDest_GetDestPageIndex: [["FPDF_DOCUMENT", "FPDF_DEST"], "int"]
  FPDFDest_GetLocationInPage: [
    [
      "FPDF_DEST",
      "FPDF_BOOL *",
      "FPDF_BOOL *",
      "FPDF_BOOL *",
      "FS_FLOAT *",
      "FS_FLOAT *",
      "FS_FLOAT *",
    ],
    "FPDF_BOOL",
  ]
  FPDFDest_GetView: [
    ["FPDF_DEST", "unsigned long *", "FS_FLOAT *"],
    "unsigned long",
  ]
  FPDFDoc_AddAttachment: [
    ["FPDF_DOCUMENT", "FPDF_WIDESTRING"],
    "FPDF_ATTACHMENT",
  ]
  FPDFDoc_CloseJavaScriptAction: [["FPDF_JAVASCRIPT_ACTION"], "void"]
  FPDFDoc_DeleteAttachment: [["FPDF_DOCUMENT", "int"], "FPDF_BOOL"]
  FPDFDOC_ExitFormFillEnvironment: [["FPDF_FORMHANDLE"], "void"]
  FPDFDoc_GetAttachment: [["FPDF_DOCUMENT", "int"], "FPDF_ATTACHMENT"]
  FPDFDoc_GetAttachmentCount: [["FPDF_DOCUMENT"], "int"]
  FPDFDoc_GetJavaScriptAction: [
    ["FPDF_DOCUMENT", "int"],
    "FPDF_JAVASCRIPT_ACTION",
  ]
  FPDFDoc_GetJavaScriptActionCount: [["FPDF_DOCUMENT"], "int"]
  FPDFDoc_GetPageMode: [["FPDF_DOCUMENT"], "int"]
  FPDFDOC_InitFormFillEnvironment: [
    ["FPDF_DOCUMENT", "FPDF_FORMFILLINFO *"],
    "FPDF_FORMHANDLE",
  ]
  FPDFFont_Close: [["FPDF_FONT"], "void"]
  FPDFFont_GetAscent: [["FPDF_FONT", "float", "float *"], "FPDF_BOOL"]
  FPDFFont_GetBaseFontName: [["FPDF_FONT", "char *", "size_t"], "size_t"]
  FPDFFont_GetDescent: [["FPDF_FONT", "float", "float *"], "FPDF_BOOL"]
  FPDFFont_GetFamilyName: [["FPDF_FONT", "char *", "size_t"], "size_t"]
  FPDFFont_GetFlags: [["FPDF_FONT"], "int"]
  FPDFFont_GetFontData: [
    ["FPDF_FONT", "uint8_t *", "size_t", "size_t *"],
    "FPDF_BOOL",
  ]
  FPDFFont_GetGlyphPath: [["FPDF_FONT", "uint32_t", "float"], "FPDF_GLYPHPATH"]
  FPDFFont_GetGlyphWidth: [
    ["FPDF_FONT", "uint32_t", "float", "float *"],
    "FPDF_BOOL",
  ]
  FPDFFont_GetIsEmbedded: [["FPDF_FONT"], "int"]
  FPDFFont_GetItalicAngle: [["FPDF_FONT", "int *"], "FPDF_BOOL"]
  FPDFFont_GetWeight: [["FPDF_FONT"], "int"]
  FPDFFormObj_CountObjects: [["FPDF_PAGEOBJECT"], "int"]
  FPDFFormObj_GetObject: [
    ["FPDF_PAGEOBJECT", "unsigned long"],
    "FPDF_PAGEOBJECT",
  ]
  FPDFFormObj_RemoveObject: [
    ["FPDF_PAGEOBJECT", "FPDF_PAGEOBJECT"],
    "FPDF_BOOL",
  ]
  FPDFGlyphPath_CountGlyphSegments: [["FPDF_GLYPHPATH"], "int"]
  FPDFGlyphPath_GetGlyphPathSegment: [
    ["FPDF_GLYPHPATH", "int"],
    "FPDF_PATHSEGMENT",
  ]
  FPDFImageObj_GetBitmap: [["FPDF_PAGEOBJECT"], "FPDF_BITMAP"]
  FPDFImageObj_GetIccProfileDataDecoded: [
    ["FPDF_PAGEOBJECT", "FPDF_PAGE", "uint8_t *", "size_t", "size_t *"],
    "FPDF_BOOL",
  ]
  FPDFImageObj_GetImageDataDecoded: [
    ["FPDF_PAGEOBJECT", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFImageObj_GetImageDataRaw: [
    ["FPDF_PAGEOBJECT", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFImageObj_GetImageFilter: [
    ["FPDF_PAGEOBJECT", "int", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFImageObj_GetImageFilterCount: [["FPDF_PAGEOBJECT"], "int"]
  FPDFImageObj_GetImageMetadata: [
    ["FPDF_PAGEOBJECT", "FPDF_PAGE", "FPDF_IMAGEOBJ_METADATA *"],
    "FPDF_BOOL",
  ]
  FPDFImageObj_GetImagePixelSize: [
    ["FPDF_PAGEOBJECT", "unsigned int *", "unsigned int *"],
    "FPDF_BOOL",
  ]
  FPDFImageObj_GetRenderedBitmap: [
    ["FPDF_DOCUMENT", "FPDF_PAGE", "FPDF_PAGEOBJECT"],
    "FPDF_BITMAP",
  ]
  FPDFImageObj_LoadJpegFile: [
    ["FPDF_PAGE *", "int", "FPDF_PAGEOBJECT", "FPDF_FILEACCESS *"],
    "FPDF_BOOL",
  ]
  FPDFImageObj_LoadJpegFileInline: [
    ["FPDF_PAGE *", "int", "FPDF_PAGEOBJECT", "FPDF_FILEACCESS *"],
    "FPDF_BOOL",
  ]
  FPDFImageObj_SetBitmap: [
    ["FPDF_PAGE *", "int", "FPDF_PAGEOBJECT", "FPDF_BITMAP"],
    "FPDF_BOOL",
  ]
  FPDFImageObj_SetMatrix: [
    [
      "FPDF_PAGEOBJECT",
      "double",
      "double",
      "double",
      "double",
      "double",
      "double",
    ],
    "FPDF_BOOL",
  ]
  FPDFJavaScriptAction_GetName: [
    ["FPDF_JAVASCRIPT_ACTION", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFJavaScriptAction_GetScript: [
    ["FPDF_JAVASCRIPT_ACTION", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFLink_CloseWebLinks: [["FPDF_PAGELINK"], "void"]
  FPDFLink_CountQuadPoints: [["FPDF_LINK"], "int"]
  FPDFLink_CountRects: [["FPDF_PAGELINK", "int"], "int"]
  FPDFLink_CountWebLinks: [["FPDF_PAGELINK"], "int"]
  FPDFLink_Enumerate: [["FPDF_PAGE", "int *", "FPDF_LINK *"], "FPDF_BOOL"]
  FPDFLink_GetAction: [["FPDF_LINK"], "FPDF_ACTION"]
  FPDFLink_GetAnnot: [["FPDF_PAGE", "FPDF_LINK"], "FPDF_ANNOTATION"]
  FPDFLink_GetAnnotRect: [["FPDF_LINK", "FS_RECTF *"], "FPDF_BOOL"]
  FPDFLink_GetDest: [["FPDF_DOCUMENT", "FPDF_LINK"], "FPDF_DEST"]
  FPDFLink_GetLinkAtPoint: [["FPDF_PAGE", "double", "double"], "FPDF_LINK"]
  FPDFLink_GetLinkZOrderAtPoint: [["FPDF_PAGE", "double", "double"], "int"]
  FPDFLink_GetQuadPoints: [
    ["FPDF_LINK", "int", "FS_QUADPOINTSF *"],
    "FPDF_BOOL",
  ]
  FPDFLink_GetRect: [
    [
      "FPDF_PAGELINK",
      "int",
      "int",
      "double *",
      "double *",
      "double *",
      "double *",
    ],
    "FPDF_BOOL",
  ]
  FPDFLink_GetTextRange: [
    ["FPDF_PAGELINK", "int", "int *", "int *"],
    "FPDF_BOOL",
  ]
  FPDFLink_GetURL: [["FPDF_PAGELINK", "int", "unsigned short *", "int"], "int"]
  FPDFLink_LoadWebLinks: [["FPDF_TEXTPAGE"], "FPDF_PAGELINK"]
  FPDFPage_CloseAnnot: [["FPDF_ANNOTATION"], "void"]
  FPDFPage_CountObjects: [["FPDF_PAGE"], "int"]
  FPDFPage_CreateAnnot: [
    ["FPDF_PAGE", "FPDF_ANNOTATION_SUBTYPE"],
    "FPDF_ANNOTATION",
  ]
  FPDFPage_Delete: [["FPDF_DOCUMENT", "int"], "void"]
  FPDFPage_Flatten: [["FPDF_PAGE", "int"], "int"]
  FPDFPage_FormFieldZOrderAtPoint: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "double", "double"],
    "int",
  ]
  FPDFPage_GenerateContent: [["FPDF_PAGE"], "FPDF_BOOL"]
  FPDFPage_GetAnnot: [["FPDF_PAGE", "int"], "FPDF_ANNOTATION"]
  FPDFPage_GetAnnotCount: [["FPDF_PAGE"], "int"]
  FPDFPage_GetAnnotIndex: [["FPDF_PAGE", "FPDF_ANNOTATION"], "int"]
  FPDFPage_GetArtBox: [
    ["FPDF_PAGE", "float *", "float *", "float *", "float *"],
    "FPDF_BOOL",
  ]
  FPDFPage_GetBleedBox: [
    ["FPDF_PAGE", "float *", "float *", "float *", "float *"],
    "FPDF_BOOL",
  ]
  FPDFPage_GetCropBox: [
    ["FPDF_PAGE", "float *", "float *", "float *", "float *"],
    "FPDF_BOOL",
  ]
  FPDFPage_GetDecodedThumbnailData: [
    ["FPDF_PAGE", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFPage_GetMediaBox: [
    ["FPDF_PAGE", "float *", "float *", "float *", "float *"],
    "FPDF_BOOL",
  ]
  FPDFPage_GetObject: [["FPDF_PAGE", "int"], "FPDF_PAGEOBJECT"]
  FPDFPage_GetRawThumbnailData: [
    ["FPDF_PAGE", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFPage_GetRotation: [["FPDF_PAGE"], "int"]
  FPDFPage_GetThumbnailAsBitmap: [["FPDF_PAGE"], "FPDF_BITMAP"]
  FPDFPage_GetTrimBox: [
    ["FPDF_PAGE", "float *", "float *", "float *", "float *"],
    "FPDF_BOOL",
  ]
  FPDFPage_HasFormFieldAtPoint: [
    ["FPDF_FORMHANDLE", "FPDF_PAGE", "double", "double"],
    "int",
  ]
  FPDFPage_HasTransparency: [["FPDF_PAGE"], "FPDF_BOOL"]
  FPDFPage_InsertClipPath: [["FPDF_PAGE", "FPDF_CLIPPATH"], "void"]
  FPDFPage_InsertObject: [["FPDF_PAGE", "FPDF_PAGEOBJECT"], "void"]
  FPDFPage_InsertObjectAtIndex: [
    ["FPDF_PAGE", "FPDF_PAGEOBJECT", "size_t"],
    "FPDF_BOOL",
  ]
  FPDFPage_New: [["FPDF_DOCUMENT", "int", "double", "double"], "FPDF_PAGE"]
  FPDFPage_RemoveAnnot: [["FPDF_PAGE", "int"], "FPDF_BOOL"]
  FPDFPage_RemoveObject: [["FPDF_PAGE", "FPDF_PAGEOBJECT"], "FPDF_BOOL"]
  FPDFPage_SetArtBox: [
    ["FPDF_PAGE", "float", "float", "float", "float"],
    "void",
  ]
  FPDFPage_SetBleedBox: [
    ["FPDF_PAGE", "float", "float", "float", "float"],
    "void",
  ]
  FPDFPage_SetCropBox: [
    ["FPDF_PAGE", "float", "float", "float", "float"],
    "void",
  ]
  FPDFPage_SetMediaBox: [
    ["FPDF_PAGE", "float", "float", "float", "float"],
    "void",
  ]
  FPDFPage_SetRotation: [["FPDF_PAGE", "int"], "void"]
  FPDFPage_SetTrimBox: [
    ["FPDF_PAGE", "float", "float", "float", "float"],
    "void",
  ]
  FPDFPage_TransformAnnots: [
    ["FPDF_PAGE", "double", "double", "double", "double", "double", "double"],
    "void",
  ]
  FPDFPage_TransFormWithClip: [
    ["FPDF_PAGE", "FS_MATRIX *", "FS_RECTF *"],
    "FPDF_BOOL",
  ]
  FPDFPageObj_AddMark: [
    ["FPDF_PAGEOBJECT", "FPDF_BYTESTRING"],
    "FPDF_PAGEOBJECTMARK",
  ]
  FPDFPageObj_CountMarks: [["FPDF_PAGEOBJECT"], "int"]
  FPDFPageObj_CreateNewPath: [["float", "float"], "FPDF_PAGEOBJECT"]
  FPDFPageObj_CreateNewRect: [
    ["float", "float", "float", "float"],
    "FPDF_PAGEOBJECT",
  ]
  FPDFPageObj_CreateTextObj: [
    ["FPDF_DOCUMENT", "FPDF_FONT", "float"],
    "FPDF_PAGEOBJECT",
  ]
  FPDFPageObj_Destroy: [["FPDF_PAGEOBJECT"], "void"]
  FPDFPageObj_GetBounds: [
    ["FPDF_PAGEOBJECT", "float *", "float *", "float *", "float *"],
    "FPDF_BOOL",
  ]
  FPDFPageObj_GetClipPath: [["FPDF_PAGEOBJECT"], "FPDF_CLIPPATH"]
  FPDFPageObj_GetDashArray: [
    ["FPDF_PAGEOBJECT", "float *", "size_t"],
    "FPDF_BOOL",
  ]
  FPDFPageObj_GetDashCount: [["FPDF_PAGEOBJECT"], "int"]
  FPDFPageObj_GetDashPhase: [["FPDF_PAGEOBJECT", "float *"], "FPDF_BOOL"]
  FPDFPageObj_GetFillColor: [
    [
      "FPDF_PAGEOBJECT",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObj_GetIsActive: [["FPDF_PAGEOBJECT", "FPDF_BOOL *"], "FPDF_BOOL"]
  FPDFPageObj_GetLineCap: [["FPDF_PAGEOBJECT"], "int"]
  FPDFPageObj_GetLineJoin: [["FPDF_PAGEOBJECT"], "int"]
  FPDFPageObj_GetMark: [
    ["FPDF_PAGEOBJECT", "unsigned long"],
    "FPDF_PAGEOBJECTMARK",
  ]
  FPDFPageObj_GetMarkedContentID: [["FPDF_PAGEOBJECT"], "int"]
  FPDFPageObj_GetMatrix: [["FPDF_PAGEOBJECT", "FS_MATRIX *"], "FPDF_BOOL"]
  FPDFPageObj_GetRotatedBounds: [
    ["FPDF_PAGEOBJECT", "FS_QUADPOINTSF *"],
    "FPDF_BOOL",
  ]
  FPDFPageObj_GetStrokeColor: [
    [
      "FPDF_PAGEOBJECT",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObj_GetStrokeWidth: [["FPDF_PAGEOBJECT", "float *"], "FPDF_BOOL"]
  FPDFPageObj_GetType: [["FPDF_PAGEOBJECT"], "int"]
  FPDFPageObj_HasTransparency: [["FPDF_PAGEOBJECT"], "FPDF_BOOL"]
  FPDFPageObj_NewImageObj: [["FPDF_DOCUMENT"], "FPDF_PAGEOBJECT"]
  FPDFPageObj_NewTextObj: [
    ["FPDF_DOCUMENT", "FPDF_BYTESTRING", "float"],
    "FPDF_PAGEOBJECT",
  ]
  FPDFPageObj_RemoveMark: [
    ["FPDF_PAGEOBJECT", "FPDF_PAGEOBJECTMARK"],
    "FPDF_BOOL",
  ]
  FPDFPageObj_SetBlendMode: [["FPDF_PAGEOBJECT", "FPDF_BYTESTRING"], "void"]
  FPDFPageObj_SetDashArray: [
    ["FPDF_PAGEOBJECT", "float *", "size_t", "float"],
    "FPDF_BOOL",
  ]
  FPDFPageObj_SetDashPhase: [["FPDF_PAGEOBJECT", "float"], "FPDF_BOOL"]
  FPDFPageObj_SetFillColor: [
    [
      "FPDF_PAGEOBJECT",
      "unsigned int",
      "unsigned int",
      "unsigned int",
      "unsigned int",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObj_SetIsActive: [["FPDF_PAGEOBJECT", "FPDF_BOOL"], "FPDF_BOOL"]
  FPDFPageObj_SetLineCap: [["FPDF_PAGEOBJECT", "int"], "FPDF_BOOL"]
  FPDFPageObj_SetLineJoin: [["FPDF_PAGEOBJECT", "int"], "FPDF_BOOL"]
  FPDFPageObj_SetMatrix: [["FPDF_PAGEOBJECT", "FS_MATRIX *"], "FPDF_BOOL"]
  FPDFPageObj_SetStrokeColor: [
    [
      "FPDF_PAGEOBJECT",
      "unsigned int",
      "unsigned int",
      "unsigned int",
      "unsigned int",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObj_SetStrokeWidth: [["FPDF_PAGEOBJECT", "float"], "FPDF_BOOL"]
  FPDFPageObj_Transform: [
    [
      "FPDF_PAGEOBJECT",
      "double",
      "double",
      "double",
      "double",
      "double",
      "double",
    ],
    "void",
  ]
  FPDFPageObj_TransformClipPath: [
    [
      "FPDF_PAGEOBJECT",
      "double",
      "double",
      "double",
      "double",
      "double",
      "double",
    ],
    "void",
  ]
  FPDFPageObj_TransformF: [["FPDF_PAGEOBJECT", "FS_MATRIX *"], "FPDF_BOOL"]
  FPDFPageObjMark_CountParams: [["FPDF_PAGEOBJECTMARK"], "int"]
  FPDFPageObjMark_GetName: [
    ["FPDF_PAGEOBJECTMARK", "FPDF_WCHAR *", "unsigned long", "unsigned long *"],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_GetParamBlobValue: [
    [
      "FPDF_PAGEOBJECTMARK",
      "FPDF_BYTESTRING",
      "unsigned char *",
      "unsigned long",
      "unsigned long *",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_GetParamFloatValue: [
    ["FPDF_PAGEOBJECTMARK", "FPDF_BYTESTRING", "float *"],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_GetParamIntValue: [
    ["FPDF_PAGEOBJECTMARK", "FPDF_BYTESTRING", "int *"],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_GetParamKey: [
    [
      "FPDF_PAGEOBJECTMARK",
      "unsigned long",
      "FPDF_WCHAR *",
      "unsigned long",
      "unsigned long *",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_GetParamStringValue: [
    [
      "FPDF_PAGEOBJECTMARK",
      "FPDF_BYTESTRING",
      "FPDF_WCHAR *",
      "unsigned long",
      "unsigned long *",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_GetParamValueType: [
    ["FPDF_PAGEOBJECTMARK", "FPDF_BYTESTRING"],
    "FPDF_OBJECT_TYPE",
  ]
  FPDFPageObjMark_RemoveParam: [
    ["FPDF_PAGEOBJECT", "FPDF_PAGEOBJECTMARK", "FPDF_BYTESTRING"],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_SetBlobParam: [
    [
      "FPDF_DOCUMENT",
      "FPDF_PAGEOBJECT",
      "FPDF_PAGEOBJECTMARK",
      "FPDF_BYTESTRING",
      "unsigned char *",
      "unsigned long",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_SetFloatParam: [
    [
      "FPDF_DOCUMENT",
      "FPDF_PAGEOBJECT",
      "FPDF_PAGEOBJECTMARK",
      "FPDF_BYTESTRING",
      "float",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_SetIntParam: [
    [
      "FPDF_DOCUMENT",
      "FPDF_PAGEOBJECT",
      "FPDF_PAGEOBJECTMARK",
      "FPDF_BYTESTRING",
      "int",
    ],
    "FPDF_BOOL",
  ]
  FPDFPageObjMark_SetStringParam: [
    [
      "FPDF_DOCUMENT",
      "FPDF_PAGEOBJECT",
      "FPDF_PAGEOBJECTMARK",
      "FPDF_BYTESTRING",
      "FPDF_BYTESTRING",
    ],
    "FPDF_BOOL",
  ]
  FPDFPath_BezierTo: [
    ["FPDF_PAGEOBJECT", "float", "float", "float", "float", "float", "float"],
    "FPDF_BOOL",
  ]
  FPDFPath_Close: [["FPDF_PAGEOBJECT"], "FPDF_BOOL"]
  FPDFPath_CountSegments: [["FPDF_PAGEOBJECT"], "int"]
  FPDFPath_GetDrawMode: [
    ["FPDF_PAGEOBJECT", "int *", "FPDF_BOOL *"],
    "FPDF_BOOL",
  ]
  FPDFPath_GetPathSegment: [["FPDF_PAGEOBJECT", "int"], "FPDF_PATHSEGMENT"]
  FPDFPath_LineTo: [["FPDF_PAGEOBJECT", "float", "float"], "FPDF_BOOL"]
  FPDFPath_MoveTo: [["FPDF_PAGEOBJECT", "float", "float"], "FPDF_BOOL"]
  FPDFPath_SetDrawMode: [["FPDF_PAGEOBJECT", "int", "FPDF_BOOL"], "FPDF_BOOL"]
  FPDFPathSegment_GetClose: [["FPDF_PATHSEGMENT"], "FPDF_BOOL"]
  FPDFPathSegment_GetPoint: [
    ["FPDF_PATHSEGMENT", "float *", "float *"],
    "FPDF_BOOL",
  ]
  FPDFPathSegment_GetType: [["FPDF_PATHSEGMENT"], "int"]
  FPDFSignatureObj_GetByteRange: [
    ["FPDF_SIGNATURE", "int *", "unsigned long"],
    "unsigned long",
  ]
  FPDFSignatureObj_GetContents: [
    ["FPDF_SIGNATURE", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFSignatureObj_GetDocMDPPermission: [["FPDF_SIGNATURE"], "unsigned int"]
  FPDFSignatureObj_GetReason: [
    ["FPDF_SIGNATURE", "void *", "unsigned long"],
    "unsigned long",
  ]
  FPDFSignatureObj_GetSubFilter: [
    ["FPDF_SIGNATURE", "char *", "unsigned long"],
    "unsigned long",
  ]
  FPDFSignatureObj_GetTime: [
    ["FPDF_SIGNATURE", "char *", "unsigned long"],
    "unsigned long",
  ]
  FPDFText_ClosePage: [["FPDF_TEXTPAGE"], "void"]
  FPDFText_CountChars: [["FPDF_TEXTPAGE"], "int"]
  FPDFText_CountRects: [["FPDF_TEXTPAGE", "int", "int"], "int"]
  FPDFText_FindClose: [["FPDF_SCHHANDLE"], "void"]
  FPDFText_FindNext: [["FPDF_SCHHANDLE"], "FPDF_BOOL"]
  FPDFText_FindPrev: [["FPDF_SCHHANDLE"], "FPDF_BOOL"]
  FPDFText_FindStart: [
    ["FPDF_TEXTPAGE", "FPDF_WIDESTRING", "unsigned long", "int"],
    "FPDF_SCHHANDLE",
  ]
  FPDFText_GetBoundedText: [
    [
      "FPDF_TEXTPAGE",
      "double",
      "double",
      "double",
      "double",
      "unsigned short *",
      "int",
    ],
    "int",
  ]
  FPDFText_GetCharAngle: [["FPDF_TEXTPAGE", "int"], "float"]
  FPDFText_GetCharBox: [
    ["FPDF_TEXTPAGE", "int", "double *", "double *", "double *", "double *"],
    "FPDF_BOOL",
  ]
  FPDFText_GetCharIndexAtPos: [
    ["FPDF_TEXTPAGE", "double", "double", "double", "double"],
    "int",
  ]
  FPDFText_GetCharIndexFromTextIndex: [["FPDF_TEXTPAGE", "int"], "int"]
  FPDFText_GetCharOrigin: [
    ["FPDF_TEXTPAGE", "int", "double *", "double *"],
    "FPDF_BOOL",
  ]
  FPDFText_GetFillColor: [
    [
      "FPDF_TEXTPAGE",
      "int",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
    ],
    "FPDF_BOOL",
  ]
  FPDFText_GetFontInfo: [
    ["FPDF_TEXTPAGE", "int", "void *", "unsigned long", "int *"],
    "unsigned long",
  ]
  FPDFText_GetFontSize: [["FPDF_TEXTPAGE", "int"], "double"]
  FPDFText_GetFontWeight: [["FPDF_TEXTPAGE", "int"], "int"]
  FPDFText_GetLooseCharBox: [
    ["FPDF_TEXTPAGE", "int", "FS_RECTF *"],
    "FPDF_BOOL",
  ]
  FPDFText_GetMatrix: [["FPDF_TEXTPAGE", "int", "FS_MATRIX *"], "FPDF_BOOL"]
  FPDFText_GetRect: [
    ["FPDF_TEXTPAGE", "int", "double *", "double *", "double *", "double *"],
    "FPDF_BOOL",
  ]
  FPDFText_GetSchCount: [["FPDF_SCHHANDLE"], "int"]
  FPDFText_GetSchResultIndex: [["FPDF_SCHHANDLE"], "int"]
  FPDFText_GetStrokeColor: [
    [
      "FPDF_TEXTPAGE",
      "int",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
      "unsigned int *",
    ],
    "FPDF_BOOL",
  ]
  FPDFText_GetText: [["FPDF_TEXTPAGE", "int", "int", "unsigned short *"], "int"]
  FPDFText_GetTextIndexFromCharIndex: [["FPDF_TEXTPAGE", "int"], "int"]
  FPDFText_GetTextObject: [["FPDF_TEXTPAGE", "int"], "FPDF_PAGEOBJECT"]
  FPDFText_GetUnicode: [["FPDF_TEXTPAGE", "int"], "unsigned int"]
  FPDFText_HasUnicodeMapError: [["FPDF_TEXTPAGE", "int"], "int"]
  FPDFText_IsGenerated: [["FPDF_TEXTPAGE", "int"], "int"]
  FPDFText_IsHyphen: [["FPDF_TEXTPAGE", "int"], "int"]
  FPDFText_LoadCidType2Font: [
    [
      "FPDF_DOCUMENT",
      "uint8_t *",
      "uint32_t",
      "FPDF_BYTESTRING",
      "uint8_t *",
      "uint32_t",
    ],
    "FPDF_FONT",
  ]
  FPDFText_LoadFont: [
    ["FPDF_DOCUMENT", "uint8_t *", "uint32_t", "int", "FPDF_BOOL"],
    "FPDF_FONT",
  ]
  FPDFText_LoadPage: [["FPDF_PAGE"], "FPDF_TEXTPAGE"]
  FPDFText_LoadStandardFont: [["FPDF_DOCUMENT", "FPDF_BYTESTRING"], "FPDF_FONT"]
  FPDFText_SetCharcodes: [
    ["FPDF_PAGEOBJECT", "uint32_t *", "size_t"],
    "FPDF_BOOL",
  ]
  FPDFText_SetText: [["FPDF_PAGEOBJECT", "FPDF_WIDESTRING"], "FPDF_BOOL"]
  FPDFTextObj_GetFont: [["FPDF_PAGEOBJECT"], "FPDF_FONT"]
  FPDFTextObj_GetFontSize: [["FPDF_PAGEOBJECT", "float *"], "FPDF_BOOL"]
  FPDFTextObj_GetRenderedBitmap: [
    ["FPDF_DOCUMENT", "FPDF_PAGE", "FPDF_PAGEOBJECT", "float"],
    "FPDF_BITMAP",
  ]
  FPDFTextObj_GetText: [
    ["FPDF_PAGEOBJECT", "FPDF_TEXTPAGE", "FPDF_WCHAR *", "unsigned long"],
    "unsigned long",
  ]
  FPDFTextObj_GetTextRenderMode: [["FPDF_PAGEOBJECT"], "FPDF_TEXT_RENDERMODE"]
  FPDFTextObj_SetTextRenderMode: [
    ["FPDF_PAGEOBJECT", "FPDF_TEXT_RENDERMODE"],
    "FPDF_BOOL",
  ]
  PDFKING_CopyTransparencyGroup: [["FPDF_PAGE", "FPDF_XOBJECT"], "int"]
  PDFKING_ExportPageObjects: [
    [
      "FPDF_DOCUMENT",
      "int",
      "unsigned int",
      "unsigned int",
      "void *",
      "unsigned int *",
      "unsigned int",
    ],
    "int",
  ]
  PDFKING_HelloWorld: [[], "int"]
  PDFKING_ICC_ConvertPage: [["FPDF_PAGE", "PDFKING_ICC_TRANSFORM"], "int"]
  PDFKING_ICC_CreateTransform: [
    ["unsigned char *", "unsigned int"],
    "PDFKING_ICC_TRANSFORM",
  ]
  PDFKING_ICC_DestroyTransform: [["PDFKING_ICC_TRANSFORM"], "void"]
  PDFKING_PageObj_SetClipRect: [
    ["FPDF_PAGEOBJECT", "float", "float", "float", "float"],
    "int",
  ]
  PDFKING_PageObj_SetFillColorCMYK: [
    [
      "FPDF_PAGEOBJECT",
      "unsigned int",
      "unsigned int",
      "unsigned int",
      "unsigned int",
      "unsigned int",
    ],
    "FPDF_BOOL",
  ]
  PDFKING_PageObj_SetStrokeColorCMYK: [
    [
      "FPDF_PAGEOBJECT",
      "unsigned int",
      "unsigned int",
      "unsigned int",
      "unsigned int",
      "unsigned int",
    ],
    "FPDF_BOOL",
  ]
}
